import { useSnapshot } from 'valtio';
import { useStoreActions } from '../store/actions';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import cls from '../styles/Block.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Block = () => {
  const {
    onHoverOverFloor,
    incrementSelectedFloor,
    decrementSelectedFloor,
  } = useStoreActions();

  const { selectedFloor } = useSnapshot(AppStore);

  const onNextPage = (floor: number) => {
    AppStore.currentPage = 21;
    AppStore.selectedFloor = floor;
  };

  return (
    <div className={cls.mainContainer}>
      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={incrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/1.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>1-комнатные</p>
              <p><span>Количество на этаже:</span> <span>8</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/2.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>2-комнатные</p>
              <p><span>Количество на этаже:</span> <span>18</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/3.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>3-комнатные</p>
              <p><span>Количество на этаже:</span> <span>6</span></p>
            </div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedFloor)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <LazyLoadImage
            src="./images/block.png"
            alt="Структура"
            effect="blur"
            placeholderSrc='./images/placeholder/block.png'
          />

          <svg viewBox="0 0 1180 837.33331">
            <path
              onClick={() => onNextPage(3)}
              onMouseOver={() => onHoverOverFloor(3)}
              fill="#3292ffcc"
              className={cls.floor3}
              d="M 547.81079,698.75516H 915.99267 V 651.71253H 215.6311 v 47.04263z"
            />
            <circle className={`${cls.symbol3} ${cls.hidden}`} cx="940" cy="675" r="35" fill="#333333" />
            <text className={`${cls.symbol3} ${cls.hidden}`} x="940" y="670" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol3} ${cls.hidden}`} x="940" y="695" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">3</text>

            <path
              onClick={() => onNextPage(4)}
              onMouseOver={() => onHoverOverFloor(4)}
              fill="#3292ffcc"
              className={cls.floor4}
              d="M 216.44242,645.00023H 915.44057 V 594.34347H 216.44242 Z"
            />
            <circle className={`${cls.symbol4} ${cls.hidden}`} cx="940" cy="620" r="35" fill="#333333" />
            <text className={`${cls.symbol4} ${cls.hidden}`} x="940" y="615" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol4} ${cls.hidden}`} x="940" y="640" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">4</text>

            <path
              onClick={() => onNextPage(5)}
              onMouseOver={() => onHoverOverFloor(5)}
              fill="#3292ffcc"
              className={cls.floor5}
              d="M 217.17377,591.22004H 915.03652 V 538.95045H 217.17377 Z"
            />
            <circle className={`${cls.symbol5} ${cls.hidden}`} cx="940" cy="565" r="35" fill="#333333" />
            <text className={`${cls.symbol5} ${cls.hidden}`} x="940" y="560" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol5} ${cls.hidden}`} x="940" y="585" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">5</text>

            <path
              onClick={() => onNextPage(6)}
              onMouseOver={() => onHoverOverFloor(6)}
              fill="#3292ffcc"
              className={cls.floor6}
              d="M 217.07345,535.56203H 914.80954 V 486.10718H 217.07345 Z"
            />
            <circle className={`${cls.symbol6} ${cls.hidden}`} cx="940" cy="510" r="35" fill="#333333" />
            <text className={`${cls.symbol6} ${cls.hidden}`} x="940" y="505" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol6} ${cls.hidden}`} x="940" y="530" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">6</text>

            <path
              onClick={() => onNextPage(7)}
              onMouseOver={() => onHoverOverFloor(7)}
              fill="#3292ffcc"
              className={cls.floor7}
              d="M 216.85505,481.90011H 914.98984 V 433.07267H 216.85505 Z"
            />
            <circle className={`${cls.symbol7} ${cls.hidden}`} cx="940" cy="458" r="35" fill="#333333" />
            <text className={`${cls.symbol7} ${cls.hidden}`} x="940" y="453" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol7} ${cls.hidden}`} x="940" y="478" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">7</text>

            <path
              onClick={() => onNextPage(8)}
              onMouseOver={() => onHoverOverFloor(8)}
              fill="#3292ffcc"
              className={cls.floor8}
              d="M 216.80301,428.7381H 915.10026 V 380.03816H 216.80301 Z"
            />
            <circle className={`${cls.symbol8} ${cls.hidden}`} cx="940" cy="405" r="35" fill="#333333" />
            <text className={`${cls.symbol8} ${cls.hidden}`} x="940" y="400" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol8} ${cls.hidden}`} x="940" y="425" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">8</text>

            <path
              onClick={() => onNextPage(9)}
              onMouseOver={() => onHoverOverFloor(9)}
              fill="#3292ffcc"
              className={cls.floor9}
              d="M 214.4328,374.68371H 916.43219 V 325.61018H 214.4328 Z"
            />
            <circle className={`${cls.symbol9} ${cls.hidden}`} cx="940" cy="350" r="35" fill="#333333" />
            <text className={`${cls.symbol9} ${cls.hidden}`} x="940" y="345" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol9} ${cls.hidden}`} x="940" y="370" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">9</text>

            <path
              onClick={() => onNextPage(10)}
              onMouseOver={() => onHoverOverFloor(10)}
              fill="#3292ffcc"
              className={cls.floor10}
              d="M 215.31559,322.54519H 916.61248 V 272.31181H 215.31559 Z"
            />
            <circle className={`${cls.symbol10} ${cls.hidden}`} cx="940" cy="297" r="35" fill="#333333" />
            <text className={`${cls.symbol10} ${cls.hidden}`} x="940" y="292" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol10} ${cls.hidden}`} x="940" y="317" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">10</text>

            <path
              onClick={() => onNextPage(11)}
              onMouseOver={() => onHoverOverFloor(11)}
              fill="#3292ffcc"
              className={cls.floor11}
              d="m 215.67618,270.26005h 700.35035 v -23.30294l -9.59537,-28.31724 H 225.6374l -9.826,27.82143 z"
            />
            <circle className={`${cls.symbol11} ${cls.hidden}`} cx="930" cy="245" r="35" fill="#333333" />
            <text className={`${cls.symbol11} ${cls.hidden}`} x="930" y="240" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol11} ${cls.hidden}`} x="930" y="265" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">11</text>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Block;
